// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-content-and-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-content-and-limits/flight-plan-content-and-limits.js';

mount([g0]);
